var render = function render(){var _vm=this,_c=_vm._self._c;return (!_vm.isFourthVersion)?_c('sidebar-old'):_c('sidebar-new')
}
var staticRenderFns = []

export { render, staticRenderFns }